export default abstract class QuestionBuilder {
    public constructor(
        bypassConfirmation: boolean,
        includeImageInAnswerResponse: boolean,
        isReady: boolean = false
    ) {
        this.bypassConfirmation = bypassConfirmation;
        this.includeImageInAnswerResponse = includeImageInAnswerResponse;
        this.isReady = isReady;
    }

    bypassConfirmation: boolean;

    includeImageInAnswerResponse: boolean;

    abstract answers(): string[];

    abstract setAnswer(string): void;

    isReady: boolean;
}
